Textnode.version = 1000;
Object.defineProperty(Textnode, 'name', {
  writable: true,
  value: 'Textnode'
});

export function Textnode(props: any) {

    let childText = "";
    if( props.data.components && props.data.components[0].content ) {
        childText = props.data.components[0].content;
    }
    
    return (
        <>
            {props.data.content}{childText}
        </>

    )
    
}
